import React, { useState } from "react";
import { useEffect } from "react";
import {
  Typography,
  Divider,
  Row,
  Col,
  Avatar,
  Button,
  Tooltip,
  Table,
  TableColumnsType,
  message,
} from "antd";
import {
  CaretUpOutlined,
  CaretDownOutlined,
  BranchesOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import {
  fetchRankList,
} from "../../api/stage";
import { useHistory, useLocation } from "react-router-dom";
import jwt, { JwtPayload } from "jsonwebtoken";
import { useAppSelector } from "../../store/hook";
import { login } from "../../api/login";
import { getTeam } from "../../api/team";
import { getProfile } from "../../api/account";
import { render } from "@testing-library/react";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
const { Title, Text } = Typography;
export interface IRanking {
  rank: number;
  delta: number;
  teamId: number;
  score: number;
  highDate: number;
  lastDate: number;
  count: number;
  contestId: number;
  trackId: number;
  git: string;
}
export const Rankline: React.FunctionComponent<IRanking> = (prop) => {
  const { rank, delta, teamId, score, highDate, lastDate, count, git } = prop;

  const { contestId, trackId } = prop;

  const history = useHistory();

  const key = useAppSelector((state) => state.user.key);
  const [teamName, setTeamName] = useState<string>(teamId.toString());
  const [userName, setUserName] = useState<string[]>([]);
  function auto_teamname()
  {
    setTimeout(auto_teamname,60000*10);
    return getTeam(key, contestId, trackId, teamId).then(data => {
        setTeamName(data.teamName);
        for (const user of data.members) {
          getProfile(key, user.id).then(data => {
            setUserName(x => [...x, data.name]);
          })
        }
      });
  }
  useEffect(() => {
    if (contestId === -1 || trackId === -1) {
      history.push("/404");
    } else {
      setTimeout(auto_teamname,500);
    }
  }, [key, contestId, trackId, teamId, history]);

  const colors = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];
  return (
    <Row>
      <Col
        key={`${rank}-1-rank-line`}
        span={1}
        style={{ textAlign: "left" }}
      >
        {rank}
        {delta > 0 ? (
          <span style={{ color: "#389e0d" }}>
            <CaretUpOutlined />
            <sup>{delta}</sup>
          </span>
        ) : delta < 0 ? (
          <span style={{ color: "#cf1322" }}>
            <CaretDownOutlined />
            <sub>{-delta}</sub>
          </span>
        ) : (
          <></>
        )}
      </Col>
      <Col key={`${rank}-2-rank-line`} span={7} offset={1}>
        <Avatar
          size="small"
          src={`https://avatar-1256691515.cos.ap-guangzhou.myqcloud.com/team-${teamId}.png`}
          style={{
            backgroundColor: colors[(teamId || 0) % 11],
            fontSize: "12px",
          }}
        >
          {teamName[0]}
        </Avatar>
        <Tooltip
          title={userName.map((str) => (
            <span style={{ margin: "0 5px" }}>@{str}</span>
          ))}
        >
          <Text style={{ margin: "0 10px" }}>{teamName}</Text>
        </Tooltip>
      </Col>
      <Col key={`${rank}-3-rank-line`} span={4} >
        {score < 0?t("格式正确"):score.toFixed(6)}
      </Col>
      <Col key={`${rank}-4-rank-line`} span={6} >
        {highDate ? moment(highDate).format("YYYY年MMMDo HH:mm") : ""}
      </Col>
      <Col key={`${rank}-6-rank-line`} span={2}>
        {count}
      </Col>
      <Col key={`${rank}-7-rank-line`} span={2}>
        <Tooltip title="前往仓库">
          <Button shape="circle" icon={<BranchesOutlined />} />
        </Tooltip>
        <Tooltip title="直接下载">
          <Button shape="circle" icon={<DownloadOutlined />} disabled />
        </Tooltip>
      </Col>
    </Row>
  );
}
export interface IRankList {
  contestId: number;
  trackId: number;
  stageId: number;
};

export interface ITeamRender {
  contestId: number;
  trackId: number;
  teamId: number;
}

export const TeamRender: React.FunctionComponent<ITeamRender> = (prop) => {
  const { contestId, trackId, teamId } = prop;
  const key = useAppSelector((state) => state.user.key);
  const [teamName, setTeamName] = useState<string>(teamId.toString());
  const [gitUrl, setGitUrl] = useState<string>();
  const [userName, setUserName] = useState<string[]>([]);
  const colors = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];
  function auto_teamname()
  {
    setTimeout(auto_teamname,60000*10);
    return getTeam(key, contestId, trackId, teamId).then(data => {
      setTeamName(data.teamName);
      setGitUrl(data.giturl);
      for (const user of data.members) {
        getProfile(key, user.id).then(data => {
          setUserName(x => [...x, data.name]);
        })
      }
      });
  }
  useEffect(() => {
    setTimeout(auto_teamname,500);
  }, [contestId, key, teamId, trackId]);

  return (<><Avatar
    size="small"
    src={`https://avatar-1256691515.cos.ap-guangzhou.myqcloud.com/team-${teamId}.png`}
    style={{
      backgroundColor: colors[(teamId || 0) % 11],
      fontSize: "12px",
    }}
  >
    {teamName[0]}
  </Avatar>
    <Tooltip
      title={userName.map((str) => (
        <span style={{ margin: "0 5px" }}>@{str}</span>
      ))}
    >
      <Text style={{ margin: "0 10px" }}>{teamName}</Text>
    </Tooltip>
  </>)
}
export const GitRender: React.FunctionComponent<ITeamRender> = (prop) => {
  const { contestId, trackId, teamId } = prop;
  const key = useAppSelector((state) => state.user.key);
  const [teamName, setTeamName] = useState<string>(teamId.toString());
  const [gitUrl, setGitUrl] = useState<string>("");
  const [userName, setUserName] = useState<string[]>([]);
  const colors = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];
  useEffect(() => {
    getTeam(key, contestId, trackId, teamId).then(data => {
      setTeamName(data.teamName);
      setGitUrl(data.giturl);
      for (const user of data.members) {
        getProfile(key, user.id).then(data => {
          setUserName(x => [...x, data.name]);
        })
      }
    });
  }, [contestId, key, teamId, trackId]);

  return (<>
    <Tooltip title="前往仓库">
      <Button shape="circle" icon={<BranchesOutlined />} onClick={() => { window.open(gitUrl); }} />
    </Tooltip>
    <Tooltip title="直接下载">
      <Button shape="circle" icon={<DownloadOutlined />} onClick={() => { window.open(gitUrl+"/archive/master.zip"); }}  />
    </Tooltip></>
        );
}
export const Ranklist: React.FunctionComponent<IRankList> = (prop) => {

  const { contestId, trackId, stageId } = prop;

  const location = useLocation();
  const history = useHistory();

  const status = useAppSelector((state) => state.user.user);
  const key = useAppSelector((state) => state.user.key);
  const id = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || 0
  );
  const [ranklist, setTRanklist] = useState<IRanking[]>([]);
  function auto_refresh()
  {
        setTimeout(auto_refresh,60000*10);
    return fetchRankList(key, contestId, trackId, stageId).then(async data => {
      try {
        const rankList: IRanking[] = [];
        var reverse = false;
        for (const teamId in data) {
          const rankLine: IRanking = {
            contestId,
            trackId,
            teamId: parseInt(teamId),
            score: 0,
            count: 0,
            lastDate: 0,
            highDate: 0,
            delta: 0,
            rank: 0,
            git: "",
          }
          for (const resultId in data[teamId]) {
            reverse = data[teamId][resultId].reverseRank;
            rankLine.score += data[teamId][resultId].score;
            rankLine.count += data[teamId][resultId].subCount;
            rankLine.lastDate = Math.max(rankLine.lastDate, new Date(data[teamId][resultId].subTime).getTime() || 0);
            rankLine.highDate = rankLine.lastDate;
          }
          if(rankLine.score > 0)
            rankList.push(rankLine);
        }
        rankList.sort((a, b) =>
          reverse ?a.score - b.score:b.score - a.score
        )

        for (const i in rankList) {
          rankList[i].rank = parseInt(i) + 1;
        }
        setTRanklist(rankList);
      }
      catch (e) {
        console.log(e);
      }
    })
  }
  useEffect(() => {
    if (contestId === -1 || trackId === -1 || stageId === -1) {
      history.push("/404");
    } else if (status === "guest") {
      login(location.pathname);
    } else {
      try {
        auto_refresh();
      }
      catch(e){
        console.log(e);
      }
    }
  }, [location, key, id, history, contestId, trackId, stageId, status]);

  const columns: TableColumnsType<IRanking> = [{
    title: t("排名"),
    dataIndex: 'rank',
    render(value: number, cur) {
      return (<> {value}
        {cur.delta > 0 ? (
          <span style={{ color: "#389e0d" }}>
            <CaretUpOutlined />
            <sup>{cur.delta}</sup>
          </span>
        ) : cur.delta < 0 ? (
          <span style={{ color: "#cf1322" }}>
            <CaretDownOutlined />
            <sub>{-cur.delta}</sub>
          </span>
        ) : (
          <></>
        )}</>)
    }
  }, {
    title: t("队伍"),
    dataIndex: "teamId",
    render(teamId: number) {
      return <TeamRender {...{ contestId, trackId, teamId }} />

    }
  }, {
    title: t("得分"),
    dataIndex: "score",
    render(score: number) {
      return <>{score < 0?t("格式正确"):score.toFixed(6)}</>
    }
  }, {
    title: t("有效成绩提交时间"),
    dataIndex: "highDate",
    render(highDate: number) {
      return <> {highDate ? moment(highDate).format("YYYY年MMMDo HH:mm") : ""}</>
    }
  }, {
    title: t("提交次数"),
    dataIndex: "count",
    render(count: number) {
      return <> {count}</>
    }

  }, {
    title: t("代码开源"),
    dataIndex: "teamId",
    render(teamId: number) {
      return <GitRender {...{ contestId, trackId, teamId }} />

    }
  },]

  return (
    <div className="site-layout-content">
      {/* <Row>
        <Col key="1" span={1} style={{ textAlign: "left" }}>
          <Title level={5}>排名</Title>
        </Col>
        <Col key="2" span={6} offset={2} >
          <Title level={5}>队伍</Title>
        </Col>
        <Col key="3" span={5} >
          <Title level={5}>得分</Title>
        </Col>
        <Col key="4" span={6}>
          <Title level={5}>最高分提交时间</Title>
        </Col>
        <Col key="5" span={4}>
          <Title level={5}>最后提交日期</Title>
        </Col> 
        <Col key="6" span={2}>
          <Title level={5}>次数</Title>
        </Col>
        <Col key="7" span={2}>
          <Title level={5}>代码开源</Title>
        </Col>
      </Row>
      <Divider /> */}
      {/*()=>{
        console.log(ranklist.length);
        if(ranklist.length==0)
          return (<div>排行榜未开放</div>);
        }*/
      }
      <Table
        dataSource={ranklist}
        columns={columns}
      />
      {/*ranklist.map((x) => (
        <Rankline {...x} key={`${x.rank}-rank-line`} />
      )) <Divider />*/}

    </div>
  );
}
export default Ranklist;
